<div class="container">
  <h1 class="text-warning text-center">You are not authorized to view this application.</h1>
</div>